var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPoint = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.363 0h40v40h-40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M20.363 6c7.732 0 14 6.268 14 14s-6.268 14-14 14-14-6.268-14-14 6.268-14 14-14zm1.639 7.88H16.01v13.658h3.474v-4.003h2.3c3.038 0 5.13-1.903 5.13-4.818 0-2.934-1.988-4.837-4.912-4.837zm-.928 2.66c1.458 0 2.328.767 2.328 2.186 0 1.43-.87 2.196-2.347 2.196h-1.571V16.54z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPoint);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/point.d1de029ee0a461ae880c6bf42b12cc69.svg";